import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { WORKING_HOURS_ITEMS, WorkingHoursSpecification } from '../../../../constants';
import { getMaxWorkingHoursAmount, getNumeralWord } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LaunchMode = {
  ModelSharedGPU: 'model-shared-gpu',
  InstanceTypeGPU: 'instance-type-gpu'
};
var ConfigurationType = {
  SharedReady: 'shared-ready',
  Custom: 'custom'
};
var Configuration = {
  Qwen: 'qwen-qwen-2.5',
  Google: 'google',
  Baai: 'baai',
  BlackForest: 'black-forest',
  QwenQwq: 'qwen-qwq',
  DeepSeek: 'deepseek'
};
var launchModeItems = [{
  label: 'Model Shared GPU',
  value: LaunchMode.ModelSharedGPU,
  description: 'Запуск модели с возможностью частичного потребления GPU-ресурса (в пределах его физического объема памяти)'
}, {
  label: 'Instance Type GPU',
  value: LaunchMode.InstanceTypeGPU,
  description: 'Запуск образа на преднастроенной конфигурации инстанса с поддержкой частичного потребления GPU-ресурса'
}];
var configurationTypeItems = [{
  label: 'Готовая',
  value: ConfigurationType.SharedReady,
  description: 'Преднастроенная конфигурация  для запуска популярных моделей'
}, {
  label: 'Пользовательская',
  value: ConfigurationType.Custom,
  description: 'С возможностью настроить собственную конфигурацию для запуска моделей'
}];
var configurationItems = [{
  label: 'Qwen/Qwen2.5-Coder-32B-Instruct',
  value: Configuration.Qwen,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE H100 PCIe", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 80 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 5 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 90 \u0413\u0411"]
  })
}, {
  label: 'google-bert/bert-base-uncased',
  value: Configuration.Google,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE H100 PCIe", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 4 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 10 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 1 \u0413\u0411"]
  })
}, {
  label: 'BAAI/bge-reranker-v2-m3',
  value: Configuration.Baai,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE V100 NVLink", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 4 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 15 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 1 \u0413\u0411"]
  })
}, {
  label: 'black-forest-labs/FLUX.1-dev',
  value: Configuration.BlackForest,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE H100 NVLink", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 40 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 300 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 60 \u0413\u0411"]
  })
}, {
  label: 'Qwen/QwQ-32B',
  value: Configuration.QwenQwq,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE H100 NVLink", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 80 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 5 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 70 \u0413\u0411"]
  })
}, {
  label: 'deepseek-ai/DeepSeek-R1-Distill-Llama-70B',
  value: Configuration.DeepSeek,
  description: /*#__PURE__*/_jsxs("div", {
    children: ["\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440 NVIDIA\xAE H100 NVLink", /*#__PURE__*/_jsx("br", {}), "\u0412\u0438\u0434\u0435\u043E\u043F\u0430\u043C\u044F\u0442\u044C GPU 160 \u0413\u0411", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043A ML-\u043C\u043E\u0434\u0435\u043B\u044F\u043C 4 \u043C\u043B\u043D \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432", /*#__PURE__*/_jsx("br", {}), "\u041A\u044D\u0448 ML-\u043C\u043E\u0434\u0435\u043B\u0435\u0439 150 \u0413\u0411"]
  })
}];
var GpuValues = {
  NvidiaH100Pcie: 'nvidia-h100-pcie',
  NvidiaH100NVLink: 'nvidia-h100-nvlink',
  NvidiaA100Pcie: 'nvidia-a100-pcie',
  NvidiaV100NVLink: 'nvidia-v100-nvlink'
};
var gpuItems = [{
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie
}, {
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink
}, {
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie
}, {
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink
}];
var gpuInstanceTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, GpuValues.NvidiaH100Pcie, [{
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie + '-1gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["1 GPU", /*#__PURE__*/_jsx("br", {}), "20 vCPU", /*#__PURE__*/_jsx("br", {}), "125 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie + '-2gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["2 GPU", /*#__PURE__*/_jsx("br", {}), "40 vCPU", /*#__PURE__*/_jsx("br", {}), "250 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie + '-4gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["4 GPU", /*#__PURE__*/_jsx("br", {}), "80 vCPU", /*#__PURE__*/_jsx("br", {}), "500 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie + '-6gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["6 GPU", /*#__PURE__*/_jsx("br", {}), "120 vCPU", /*#__PURE__*/_jsx("br", {}), "750 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 PCIe',
  value: GpuValues.NvidiaH100Pcie + '-8gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["8 GPU", /*#__PURE__*/_jsx("br", {}), "160 vCPU", /*#__PURE__*/_jsx("br", {}), "1000 \u0413\u0411 RAM"]
  })
}]), GpuValues.NvidiaH100NVLink, [{
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink + '-1gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["1 GPU", /*#__PURE__*/_jsx("br", {}), "20 vCPU", /*#__PURE__*/_jsx("br", {}), "190 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink + '-2gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["2 GPU", /*#__PURE__*/_jsx("br", {}), "40 vCPU", /*#__PURE__*/_jsx("br", {}), "380 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink + '-4gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["4 GPU", /*#__PURE__*/_jsx("br", {}), "80 vCPU", /*#__PURE__*/_jsx("br", {}), "760 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink + '-6gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["6 GPU", /*#__PURE__*/_jsx("br", {}), "120 vCPU", /*#__PURE__*/_jsx("br", {}), "1140 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® H100 NVLink',
  value: GpuValues.NvidiaH100NVLink + '-8gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["8 GPU", /*#__PURE__*/_jsx("br", {}), "160 vCPU", /*#__PURE__*/_jsx("br", {}), "1520 \u0413\u0411 RAM"]
  })
}]), GpuValues.NvidiaA100Pcie, [{
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie + '-1gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["1 GPU", /*#__PURE__*/_jsx("br", {}), "20 vCPU", /*#__PURE__*/_jsx("br", {}), "125 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie + '-2gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["2 GPU", /*#__PURE__*/_jsx("br", {}), "40 vCPU", /*#__PURE__*/_jsx("br", {}), "250 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie + '-4gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["4 GPU", /*#__PURE__*/_jsx("br", {}), "80 vCPU", /*#__PURE__*/_jsx("br", {}), "500 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie + '-6gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["6 GPU", /*#__PURE__*/_jsx("br", {}), "120 vCPU", /*#__PURE__*/_jsx("br", {}), "750 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® A100 PCIe',
  value: GpuValues.NvidiaA100Pcie + '-8gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["8 GPU", /*#__PURE__*/_jsx("br", {}), "160 vCPU", /*#__PURE__*/_jsx("br", {}), "1000 \u0413\u0411 RAM"]
  })
}]), GpuValues.NvidiaV100NVLink, [{
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink + '-1gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["1 GPU", /*#__PURE__*/_jsx("br", {}), "4 vCPU", /*#__PURE__*/_jsx("br", {}), "64 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink + '-2gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["2 GPU", /*#__PURE__*/_jsx("br", {}), "8 vCPU", /*#__PURE__*/_jsx("br", {}), "128 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink + '-4gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["4 GPU", /*#__PURE__*/_jsx("br", {}), "16 vCPU", /*#__PURE__*/_jsx("br", {}), "256 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink + '-8gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["8 GPU", /*#__PURE__*/_jsx("br", {}), "32 vCPU", /*#__PURE__*/_jsx("br", {}), "512 \u0413\u0411 RAM"]
  })
}, {
  label: 'NVIDIA® V100 NVLink',
  value: GpuValues.NvidiaV100NVLink + '-16gpu',
  description: /*#__PURE__*/_jsxs("div", {
    children: ["16 GPU", /*#__PURE__*/_jsx("br", {}), "64 vCPU", /*#__PURE__*/_jsx("br", {}), "1024 \u0413\u0411 RAM"]
  })
}]);
export var EVOLUTION_ML_INFERENCE_FORM_CONFIG = {
  ui: ['mlInferenceLaunchMode', 'mlInferenceConfigurationType', 'mlInferenceConfiguration', ['mlInferenceGpu', 'mlInferenceGpuMemory'], 'mlInferenceGpuInstanceType', 'mlInferenceRequests', ['mlInferenceWorkingHours', 'mlInferenceWorkingHoursSpecification']],
  controls: {
    mlInferenceLaunchMode: {
      type: CONTROL.ToggleCards,
      accessorKey: 'mlInferenceLaunchMode',
      defaultValue: LaunchMode.ModelSharedGPU,
      items: launchModeItems,
      decoratorProps: {
        label: 'Способ запуска инференса'
      }
    },
    mlInferenceConfigurationType: {
      type: CONTROL.ToggleCards,
      accessorKey: 'mlInferenceConfigurationType',
      defaultValue: ConfigurationType.SharedReady,
      items: configurationTypeItems,
      decoratorProps: {
        label: 'Тип конфигурации'
      },
      watchedControls: {
        mlInferenceLaunchMode: 'mlInferenceLaunchMode'
      },
      relateFn: function relateFn(_ref) {
        var mlInferenceLaunchMode = _ref.mlInferenceLaunchMode;
        if (mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU) {
          return {
            uiProps: {
              visible: false
            }
          };
        }
      }
    },
    mlInferenceConfiguration: {
      type: CONTROL.ToggleCards,
      accessorKey: 'mlInferenceConfiguration',
      defaultValue: Configuration.Qwen,
      items: configurationItems,
      watchedControls: {
        mlInferenceConfigurationType: 'mlInferenceConfigurationType',
        mlInferenceLaunchMode: 'mlInferenceLaunchMode'
      },
      relateFn: function relateFn(_ref2) {
        var mlInferenceConfigurationType = _ref2.mlInferenceConfigurationType,
          mlInferenceLaunchMode = _ref2.mlInferenceLaunchMode;
        if (mlInferenceConfigurationType !== ConfigurationType.SharedReady || mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU) {
          return {
            uiProps: {
              visible: false
            }
          };
        }
      },
      decoratorProps: {
        label: 'Конфигурация'
      }
    },
    mlInferenceGpu: {
      type: CONTROL.SelectSingle,
      accessorKey: 'mlInferenceGpu',
      items: gpuItems,
      decoratorProps: {
        label: 'Графический процессор'
      },
      watchedControls: {
        mlInferenceConfigurationType: 'mlInferenceConfigurationType',
        mlInferenceLaunchMode: 'mlInferenceLaunchMode'
      },
      relateFn: function relateFn(_ref3) {
        var mlInferenceConfigurationType = _ref3.mlInferenceConfigurationType,
          mlInferenceLaunchMode = _ref3.mlInferenceLaunchMode;
        if (mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU) {
          return {
            uiProps: {
              visible: true
            }
          };
        }
        if (mlInferenceConfigurationType === ConfigurationType.SharedReady) {
          return {
            uiProps: {
              visible: false
            }
          };
        }
      }
    },
    mlInferenceGpuMemory: {
      type: CONTROL.Stepper,
      accessorKey: 'mlInferenceGpuMemory',
      decoratorProps: {
        label: 'Объем видеопамяти GPU'
      },
      defaultValue: 4,
      uiProps: {
        min: 4,
        max: 80,
        postfix: 'ГБ',
        allowedValues: [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80]
      },
      watchedControls: {
        mlInferenceLaunchMode: 'mlInferenceLaunchMode',
        mlInferenceConfigurationType: 'mlInferenceConfigurationType'
      },
      relateFn: function relateFn(_ref4) {
        var mlInferenceLaunchMode = _ref4.mlInferenceLaunchMode,
          mlInferenceConfigurationType = _ref4.mlInferenceConfigurationType;
        if (mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU || mlInferenceConfigurationType === ConfigurationType.SharedReady) {
          return {
            uiProps: {
              visible: false
            }
          };
        }
      }
    },
    mlInferenceGpuInstanceType: {
      type: CONTROL.ToggleCards,
      accessorKey: 'mlInferenceGpuInstanceType',
      items: gpuInstanceTypes[GpuValues.NvidiaH100Pcie],
      decoratorProps: {
        label: 'Тип инстанса'
      },
      watchedControls: {
        mlInferenceGpu: 'mlInferenceGpu',
        mlInferenceLaunchMode: 'mlInferenceLaunchMode'
      },
      relateFn: function relateFn(_ref5) {
        var mlInferenceGpu = _ref5.mlInferenceGpu,
          mlInferenceLaunchMode = _ref5.mlInferenceLaunchMode;
        if (mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU) {
          return {
            uiProps: {
              visible: true
            },
            items: gpuInstanceTypes[mlInferenceGpu]
          };
        }
        return {
          uiProps: {
            visible: false
          }
        };
      }
    },
    mlInferenceRequests: {
      type: CONTROL.Object,
      ui: [['mlInferenceRequestsCount', 'mlInferenceCacheVolume']],
      watchedControls: {
        mlInferenceConfigurationType: 'mlInferenceConfigurationType',
        mlInferenceLaunchMode: 'mlInferenceLaunchMode'
      },
      relateFn: function relateFn(_ref6) {
        var mlInferenceConfigurationType = _ref6.mlInferenceConfigurationType,
          mlInferenceLaunchMode = _ref6.mlInferenceLaunchMode;
        if (mlInferenceLaunchMode === LaunchMode.InstanceTypeGPU) {
          return {
            visible: true
          };
        }
        if (mlInferenceConfigurationType === ConfigurationType.SharedReady) {
          return {
            visible: false
          };
        }
      },
      controls: {
        mlInferenceRequestsCount: {
          type: CONTROL.Stepper,
          accessorKey: 'mlInferenceRequestsCount',
          decoratorProps: {
            label: 'Количество запросов к ML-моделям'
          },
          defaultValue: 1,
          uiProps: {
            min: 1,
            max: 9999999999,
            postfix: 'млн. шт.',
            showHint: false
          }
        },
        mlInferenceCacheVolume: {
          type: CONTROL.Stepper,
          accessorKey: 'mlInferenceCacheVolume',
          decoratorProps: {
            label: 'Кэш ML-моделей'
          },
          defaultValue: 1,
          uiProps: {
            min: 1,
            max: 9999999999,
            postfix: 'ГБ',
            showHint: false
          }
        }
      }
    },
    mlInferenceWorkingHours: {
      type: CONTROL.Stepper,
      accessorKey: 'mlInferenceWorkingHours',
      defaultValue: 1,
      uiProps: {
        min: 1,
        max: 1,
        postfix: 'час'
      },
      decoratorProps: {
        label: 'Время работы'
      },
      watchedControls: {
        period: 'mlInferenceWorkingHoursSpecification',
        workingHours: 'mlInferenceWorkingHours'
      },
      relateFn: function relateFn(_ref7) {
        var period = _ref7.period,
          workingHours = _ref7.workingHours;
        var maxWorkingHours = getMaxWorkingHoursAmount(period, {
          hour: 1,
          day: 24,
          month: 744
        });
        var isStepperDisabled = maxWorkingHours === 1;
        return {
          uiProps: {
            min: 1,
            max: maxWorkingHours,
            showHint: !isStepperDisabled,
            disabled: isStepperDisabled,
            postfix: getNumeralWord(workingHours, ['час', 'часа', 'часов'])
          }
        };
      }
    },
    mlInferenceWorkingHoursSpecification: {
      type: CONTROL.SelectSingle,
      accessorKey: 'mlInferenceWorkingHoursSpecification',
      defaultValue: WorkingHoursSpecification.Hour,
      items: WORKING_HOURS_ITEMS,
      uiProps: {
        showClearButton: false,
        searchable: false
      },
      decoratorProps: {
        label: 'Период'
      },
      onChangePeriod: function onChangePeriod(period, setValue) {
        setValue([['mlInferenceWorkingHoursSpecification', period]]);
      },
      canChangeWholePricePeriod: true
    }
  }
};